import axios from '../../helpers/axios-setup';

export const getFeeByAppId = (appId: number) => axios.get(`/billing/fees/application/${appId}`);
